<script>
    import {page, router} from '@inertiajs/svelte';
    import {searchQuery} from '~/components/searchStore';

    export let filters = {};

    // No Packs tab: the /c browse page was removed 2026-08-03 — packs are
    // discovered through user profiles (docs/product-roadmap.md).
    let pages = [
        { title: 'Posts', href: '/p' },
        { title: 'Images', href: '/m' },
        { title: 'Tags', href: '/tags' },
    ];

    // Boundary-aware active check — a bare startsWith('/p') would light the
    // Posts tab up on /privacy.
    function isActive(url, href) {
        return url === href || url.startsWith(href + '/') || url.startsWith(href + '?');
    }

    // Switching section carries the current search-bar text so the query stays
    // active across Posts/Images. Read the store at click time to get the latest
    // typed value. Tags uses a different search axis (tag name / within a
    // selection), so we don't push the free-text query there.
    function switchSection(e, href) {
        e.preventDefault();
        // Tags has its own search axis — don't carry the free-text query there.
        if (href === '/tags') {
            router.get(href);
            return;
        }
        const q = ($searchQuery || '').trim();
        const params = { ...filters };
        if (q) params.q = q; else delete params.q;
        router.get(href, params);
    }
</script>

<div class="flex">
    {#each pages as {title, href}}
        <a {href}
           onclick={(e) => switchSection(e, href)}
           class="py-2 px-3 md:px-4 text-sm md:text-base font-bold border-b-2 transition-colors
                  {isActive($page.url, href) ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}">
            {title}
        </a>
    {/each}
</div>
